import API from '~config/api';
import { ApiPromise, DataResponse, ErrorResponse } from '~globals/types';

import {
  RouteReportItemsInProgressFilters,
  RouteReportItemsInProgressResponse,
  RouteReportItemsInProgressByRouteFilters,
  RouteReportItemsInProgressByRouteResponse,
  RouteReportItemsInProgressByZoneFilters,
  RouteReportItemsInProgressByZoneResponse,
  RouteReportItemsInProgressByCompanyFilters,
  RouteReportItemsInProgressByCompanyResponse,
  RouteReportCollectedItemsFilters,
  RouteReportCollectedItemsResponse,
  RouteReportCollectedItemsByDriverFilters,
  RouteReportCollectedItemsByDriverResponse,
  RouteReportCollectedItemsByZoneFilters,
  RouteReportCollectedItemsByZoneResponse,
  RouteReportCollectedItemsByCompanyFilters,
  RouteReportCollectedItemsByCompanyResponse,
} from './types';

export const ROUTE_REPORTS_ENPOINTS = {
  getItemsInProgress: '/api/v1/Route/Report/ItemsInProgress',
  getItemsInProgressByRoute: '/api/v1/Route/Report/ItemsInProgressByRoute',
  getItemsInProgressByZone: '/api/v1/Route/Report/ItemsInProgressByZone',
  getItemsInProgressByCompany: '/api/v1/Route/Report/ItemsInProgressByCompany',
  getCollectedItems: '/api/v1/Route/Report/CollectedItems',
  getCollectedItemsByDriver: '/api/v1/Route/Report/CollectedItemsByDriver',
  getCollectedItemsByZone: '/api/v1/Route/Report/CollectedItemsByZone',
  getCollectedItemsByCompany: '/api/v1/Route/Report/CollectedItemsByCompany',
};

export const getItemsInProgress = (
  filters: RouteReportItemsInProgressFilters,
): ApiPromise<
  DataResponse<RouteReportItemsInProgressResponse>,
  ErrorResponse
> =>
  API.post<DataResponse<RouteReportItemsInProgressResponse>, ErrorResponse>(
    ROUTE_REPORTS_ENPOINTS.getItemsInProgress,
    { ...filters, excelMode: false },
  );

export const getItemsInProgressToExport = (
  filters: RouteReportItemsInProgressFilters,
): ApiPromise<Blob, ErrorResponse> =>
  API.post<Blob, ErrorResponse>(
    ROUTE_REPORTS_ENPOINTS.getItemsInProgress,
    { ...filters, excelMode: true },
    { responseType: 'blob', timeout: 120000 },
  );

export const getItemsInProgressByRoute = (
  filters: RouteReportItemsInProgressByRouteFilters,
): ApiPromise<
  DataResponse<RouteReportItemsInProgressByRouteResponse>,
  ErrorResponse
> =>
  API.post<
    DataResponse<RouteReportItemsInProgressByRouteResponse>,
    ErrorResponse
  >(ROUTE_REPORTS_ENPOINTS.getItemsInProgressByRoute, filters);

export const getItemsInProgressByZone = (
  filters: RouteReportItemsInProgressByZoneFilters,
): ApiPromise<
  DataResponse<RouteReportItemsInProgressByZoneResponse>,
  ErrorResponse
> =>
  API.post<
    DataResponse<RouteReportItemsInProgressByZoneResponse>,
    ErrorResponse
  >(ROUTE_REPORTS_ENPOINTS.getItemsInProgressByZone, filters);

export const getItemsInProgressByCompany = (
  filters: RouteReportItemsInProgressByCompanyFilters,
): ApiPromise<
  DataResponse<RouteReportItemsInProgressByCompanyResponse>,
  ErrorResponse
> =>
  API.post<
    DataResponse<RouteReportItemsInProgressByCompanyResponse>,
    ErrorResponse
  >(ROUTE_REPORTS_ENPOINTS.getItemsInProgressByCompany, filters);

export const getCollectedItems = (
  filters: RouteReportCollectedItemsFilters,
): ApiPromise<DataResponse<RouteReportCollectedItemsResponse>, ErrorResponse> =>
  API.post<DataResponse<RouteReportCollectedItemsResponse>, ErrorResponse>(
    ROUTE_REPORTS_ENPOINTS.getCollectedItems,
    { ...filters, excelMode: false },
  );

export const getCollectedItemsToExport = (
  filters: RouteReportCollectedItemsFilters,
): ApiPromise<Blob, ErrorResponse> =>
  API.post<Blob, ErrorResponse>(
    ROUTE_REPORTS_ENPOINTS.getCollectedItems,
    { ...filters, excelMode: true },
    { responseType: 'blob', timeout: 120000 },
  );

export const getCollectedItemsByDriver = (
  filters: RouteReportCollectedItemsByDriverFilters,
): ApiPromise<
  DataResponse<RouteReportCollectedItemsByDriverResponse>,
  ErrorResponse
> =>
  API.post<
    DataResponse<RouteReportCollectedItemsByDriverResponse>,
    ErrorResponse
  >(ROUTE_REPORTS_ENPOINTS.getCollectedItemsByDriver, filters);

export const getCollectedItemsByZone = (
  filters: RouteReportCollectedItemsByZoneFilters,
): ApiPromise<
  DataResponse<RouteReportCollectedItemsByZoneResponse>,
  ErrorResponse
> =>
  API.post<
    DataResponse<RouteReportCollectedItemsByZoneResponse>,
    ErrorResponse
  >(ROUTE_REPORTS_ENPOINTS.getCollectedItemsByZone, filters);

export const getCollectedItemsByCompany = (
  filters: RouteReportCollectedItemsByCompanyFilters,
): ApiPromise<
  DataResponse<RouteReportCollectedItemsByCompanyResponse>,
  ErrorResponse
> =>
  API.post<
    DataResponse<RouteReportCollectedItemsByCompanyResponse>,
    ErrorResponse
  >(ROUTE_REPORTS_ENPOINTS.getCollectedItemsByCompany, filters);
